import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ApplyCoupon } from '../../redux/Slices/CartSlice'
import notify from '../UseNotification'

const UseApplyCoupon = () => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(true)
    const [couponName, setCouponName] = useState("")
    const { applyCoupon } = useSelector(state => state.CartReducer)


    // to get coupon name
    const onChangeCouponName = (e) => {
        setCouponName(e.target.value)
    }

    // to handle apply coupon value
    const handleApplyCouponFunc = async () => {
        if (couponName === "") {
            notify("Please enter the coupon", "warn");
            return;
        }
        setLoading(true)
        await dispatch(ApplyCoupon({
            couponName: couponName
        }))
        setLoading(false)
    }

    // handle apply coupon request response
    useEffect(() => {
        if (loading === false) {
            if (applyCoupon.status === 200) {
                if (applyCoupon && applyCoupon.data) {
                    notify(`your ${applyCoupon.data.coupon} is success`, "success")
                    window.location.reload(false)
                }
            } else {
                notify(applyCoupon.response.data.message, "error")
            }
        }
    }, [loading])


    return [handleApplyCouponFunc, onChangeCouponName]
}

export default UseApplyCoupon
